module.exports = __webpack_public_path__ + "assets/img/aboutUS-module2.9623ff28.png";